<template>
  <div class="scrollable">
    <div ref="scrollableContent" class="scrollable__content scrollbar">
      <slot />
    </div>
    <div
      class="scrollable__fade scrollable__fade"
      :class="{ 'scrollable__fade--hide': !showBottomFade }"
    />
  </div>
</template>

<script>
export default {
  name: 'Scrollable',
  data() {
    return {
      showBottomFade: false,
    };
  },
  updated() {
    this.handleScrollFade();
  },
  mounted() {
    this.$refs.scrollableContent.addEventListener(
      'scroll',
      this.handleEmitAndScrollFade,
      { passive: true },
    );
    this.handleScrollFade();
  },
  beforeDestroy() {
    this.$refs.scrollableContent.removeEventListener(
      'scroll',
      this.handleEmitAndScrollFade,
    );
  },
  methods: {
    handleEmitAndScrollFade() {
      this.handleScrollFade();

      this.$emit('scroll', this.$refs.scrollableContent);
    },
    handleScrollFade() {
      const EDGE_DISTANCES = 5;

      const {
        scrollTop,
        offsetHeight,
        scrollHeight,
      } = this.$refs.scrollableContent;

      if (scrollTop + EDGE_DISTANCES >= scrollHeight - offsetHeight) {
        this.showBottomFade = false;
      } else this.showBottomFade = true;
    },
  },
};
</script>

<style lang="scss">
.scrollable {
  $fade-color: #fff;

  position: relative;
  overflow: hidden;

  &__content {
    height: 100%;
    width: 100%;
    overflow-y: auto;
    scroll-behavior: smooth;
  }

  &__fade {
    position: absolute;
    right: 0;
    width: calc(100% - #{rem-calc(3px)});
    height: 30%;
    pointer-events: none;
    transition-duration: 0.3s;

    bottom: 0;
    background: linear-gradient(to bottom, transparent, $fade-color 90%);

    &--hide {
      opacity: 0;
      visibility: hidden;
    }
  }
}
</style>
